<template>
  <el-form
    :model="form"
    :rules="rules"
    ref="mobile"
    size="small"
    label-position="left"
    label-width="290px"
  >
    <el-dialog
      :class="dialogclass"
      width="75%"
      :visible.sync="popup"
    >
      <h3 slot="title">Que souhaitez-vous résilier ?</h3>

      <div class="choice-logo">
        <el-radio v-model="form.type" label="canal" border>
          Mon abonnement à Canal+
          <img src="/static/images/logos/canal.png" />
        </el-radio>
        <el-radio v-if="defaultType === 'canalplay'" v-model="form.type" label="canalplay" border>
          Mon abonnement Canal Play
          <img src="/static/images/logos/canalplay.png" />
        </el-radio>
        <el-radio v-else-if="defaultType === 'canalfoot'" v-model="form.type" label="canalfoot" border>
          Mon abonnement Foot+/Rugby+
          <img src="/static/images/logos/canalfoot.png" />
        </el-radio>
        <el-radio v-else v-model="form.type" label="canalsat" border>
          Mon abonnement Canalsat
          <img src="/static/images/logos/canalsat.png" />
        </el-radio>
      </div>

      <el-button type="danger" @click.prevent="close()">
        Continuer
      </el-button>

      <div class="info">
        <p><strong>Attention, vous devez vous désabonner 1 mois avant votre date d’échéance pour que
          votre abonnement ne soit plus renouvelé.</strong></p>
        <p><strong>Vous avez trois solutions pour connaître votre date d’échéance :</strong><br>
          Sur votre avis d’échéance. Canal+ doit aussi y inscrire la date limite de notification de
          non reconduction de l’abonnement.<br>
          Sur votre contrat d’abonnement à Canal +.<br>
          Sur votre espace client.</p>
      </div>
    </el-dialog>

    <div class="choice">
      <template v-if="defaultType === 'canal'">
        <el-radio v-model="form.type" label="canal" border>Je souhaite résilier mon abonnement à Canal+</el-radio>
        <el-radio v-model="form.type" label="canalsat" border>Je souhaite résilier mon abonnement Canalsat</el-radio>
      </template>
      <template v-else-if="defaultType === 'canalplay'">
        <el-radio v-model="form.type" label="canalplay" border>Je souhaite résilier mon abonnement Canal Play</el-radio>
        <el-radio v-model="form.type" label="canal" border>Je souhaite résilier mon abonnement à Canal+</el-radio>
      </template>
      <template v-else-if="defaultType === 'canalfoot'">
        <el-radio v-model="form.type" label="canalfoot" border>Je souhaite résilier mon abonnement Foot+/Rugby+</el-radio>
        <el-radio v-model="form.type" label="canal" border>Je souhaite résilier mon abonnement à Canal+</el-radio>
      </template>
      <template v-else>
        <el-radio v-model="form.type" label="canalsat" border>Je souhaite résilier mon abonnement Canalsat</el-radio>
        <el-radio v-model="form.type" label="canal" border>Je souhaite résilier mon abonnement à Canal+</el-radio>
      </template>
    </div>

    <p style="border-bottom: 1px solid #f1f1f1;padding-bottom:10px">Vous devez saisir les informations ci-dessous pour résilier votre abonnement :</p>

    <el-form-item prop="contract" required>
      <span slot="label" class="label-logo">
        Numéro client <img :src="logo"  :class="classname" />
      </span>
      <el-input v-model="form.contract" />
      <span class="notice">
        <i class="el-icon-info" /> {{ title }}
      </span>
    </el-form-item>

    <div class="info small">
      <p><strong>Attention, vous devez vous désabonner 1 mois avant votre date d’échéance pour que
        votre abonnement ne soit plus renouvelé.</strong></p>
      <p><strong>Vous avez trois solutions pour connaître votre date d’échéance :</strong><br>
        Sur votre avis d’échéance. Canal+ doit aussi y inscrire la date limite de notification de
        non reconduction de l’abonnement.<br>
        Sur votre contrat d’abonnement à Canal +.<br>
        Sur votre espace client.</p>
    </div>

    <Cgu
      id="cgu"
      :rows="8"
      :contact="contact"
      currency="eur"
    />

    <el-form-item class="cgu" prop="cgu">
      <el-checkbox v-model="form.cgu">
        J'ai lu et j'accepte les conditions générales ci-dessus
      </el-checkbox>
    </el-form-item>

    <div class="valider">
      <el-button
        round
        icon="el-icon-caret-right"
        type="danger"
        :loading="loading"
        @click.prevent="valide"
      >
        Je valide ma demande
      </el-button>

      <p class="delai">
        la résiliation sera effective dans un délai de dix jours maximum à compter de la réception
        du dossier.
        <span class="legal">(Conformément aux dispositions de l’article L.224-39 du code de la
          consommation)</span>
      </p>

      <img src="../../assets/images/secure-payment.png" />
    </div>
  </el-form>
</template>

<script>
import Cgu from '../cgu.vue'

export default {
  props: {
    contract: String,
    loading: Boolean,
    contact: String,
    type: String,
    description: String,
    reference: String,
    title: String
  },
  components: {
    Cgu
  },
  data () {
    const cgu = (rule, value, callback) => {
      if (value !== true) {
        callback(new Error('Vous devez lire et accepter les conditions générales'))
      } else {
        callback()
      }
    }
    return {
      popup: true,
      defaultType: this.type,
      form: {
        contract: this.contract,
        type: this.type,
        cgu: false
      },
      rules: {
        contract: [
          { required: true, message: 'Saisissez votre ' + this.reference, trigger: 'blur' }
        ],
        cgu: [
          { validator: cgu, trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    logo () {
      return '/static/images/logos/' + this.classname + '.png'
    },
    dialogclass () {
      return 'pre-select ' + this.classname + '-select'
    },
    classname () {
      return this.type.replace(/\s+/g, '').toLowerCase()
    }
  },
  methods: {
    valide () {
      this.$refs.mobile.validate((valid) => {
        if (valid) {
          this.$emit('valide', this.form)
        }
      })
    },
    close () {
      this.popup = false
      this.$refs.phone.onFieldBlur()
    }
  },
  watch: {
    contract (value) {
      this.form.contract = value
    },
    type (value) {
      this.form.type = value
    },
    form: {
      handler (value) {
        if (value) {
          this.$emit('update:type', value.type)
          this.$emit('update:contract', value.contract)
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
  #cgu {
    height: 8em;
    overflow: auto;
    max-width: 600px;
    margin: 50px auto 30px;
    text-align: left;
    font-size: 11px;
  }
  .valider {
    img {
      max-width: 250px;
      margin-top: 25px;
    }
  }
  .delai {
    margin-top: 40px;
    color: #000;
    font-size: 14px;

    .legal {
      font-size: 10px;
      display: block;
    }
  }
  .notice {
    color: #444;
    font-size: 12px;
  }
  .el-select {
    width: 100%;
  }
  .choice {
    padding: 50px 0;
  }
  .info {
    padding-top: 15px;
    color: #000;
    font-size: 16px;

    &.small {
      font-size: 12px;
      padding-top: 0;
    }
  }
  @media (max-width: 767px) {
    .choice {
      padding: 0;

      .el-radio {
        width: 100%;
        margin: 0 0 5px 0 !important;
      }
    }
  }
</style>

<style lang="scss">
  .el-form-item.cgu {
    max-width: 600px;
    margin: 0 auto 15px !important;

    .el-form-item__content {
      padding-top: 10px;
      margin-left: 0 !important;
      text-align: center;
    }
    .el-checkbox__label {
      font-weight: bold;
      font-size: 16px;
    }
  }
  .pre-select {
    .el-dialog__header {
      background-size: 125px;
      background-position: top center;
      background-repeat: no-repeat;
      padding-top: 50px;
    }
    .el-button {
      margin-top: 40px;
    }
  }
  .choice-logo {
    position: relative;

    .el-radio {
      padding-bottom: 100px !important;
    }
    img {
      max-height: 48px;
      display: block;
      margin: 15px auto 0;
      padding-left: 10px;
    }
  }
  .label-logo {
    position: relative;

    img {
      max-height: 24px;
      position: absolute;
      left: 110px;
      top: -3px;

      &.orange {
        max-height: 64px;
        left: 90px;
        top: -23px;
      }
    }
  }

  .el-dialog__body .choice-logo .el-radio {
    padding-bottom: 20px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/canal.vue